document.addEventListener("DOMContentLoaded", function () {
  const sliderList = document.querySelector('.feature-media-list');
   // Stop script if on `.salty-massager` product page
  if (document.body.classList.contains('salty-massager')) {
    console.log("Swipe script disabled on .salty-massager page ❌");
    return;
  }

  
  // Run only on mobile
  if (!sliderList || window.innerWidth > 768) {
    return;
  }
  
  let startX = 0;
  let endX = 0;
  let startY = 0;
  let endY = 0;
  let isSwiping = false;
  let hasMoved = false;
  
  sliderList.addEventListener('touchstart', function (e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    endX = startX;
    endY = startY;
    isSwiping = false;
    hasMoved = false;
    console.log("Touch start:", startX);
  }, { passive: true });
  
  sliderList.addEventListener('touchmove', function (e) {
    endX = e.touches[0].clientX;
    endY = e.touches[0].clientY;
    
    const diffX = Math.abs(startX - endX);
    const diffY = Math.abs(startY - endY);
    
    // Only consider it swiping if horizontal movement is greater than vertical
    if (diffX > diffY && diffX > 10) {
      isSwiping = true;
      hasMoved = true;
      // Prevent default scrolling when we're clearly swiping horizontally
      e.preventDefault();
    } else if (diffX > 5 || diffY > 5) {
      hasMoved = true;
    }
    
    console.log("Touch move:", endX, "Swiping:", isSwiping);
  });
  
  sliderList.addEventListener('touchend', function (e) {
    const diffX = startX - endX;
    const diffY = Math.abs(startY - endY);
    
    console.log("Touch end. Difference X:", diffX, "Y:", diffY, "Has moved:", hasMoved);
    
    // Only trigger swipe if we actually swiped horizontally and moved enough
    if (isSwiping && Math.abs(diffX) > 50 && Math.abs(diffX) > diffY) {
      // Prevent any click events from firing
      e.preventDefault();
      
    //   if (diffX > 0) {
    //     console.log("Swipe Left 👉");
    //     document.querySelector('.splide__arrow--next')?.click();
    //   } else {
    //     console.log("Swipe Right 👈");
    //     document.querySelector('.splide__arrow--prev')?.click();
    //   }
    } else if (!hasMoved) {
      // This was a tap, not a swipe - allow normal click behavior
      console.log("Tap detected, allowing normal click ✅");
    } else {
      console.log("Swipe too small or vertical, ignored ❌");
    }
  }, { passive: false });
  
  // Additional safeguard: prevent click events immediately after swipes
  let lastSwipeTime = 0;
  sliderList.addEventListener('click', function(e) {
    if (Date.now() - lastSwipeTime < 300) {
      console.log("Preventing click after swipe");
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  
  // Update lastSwipeTime when arrows are clicked
  document.querySelector('.splide__arrow--next')?.addEventListener('click', () => {
    lastSwipeTime = Date.now();
  });
  document.querySelector('.splide__arrow--prev')?.addEventListener('click', () => {
    lastSwipeTime = Date.now();
  });
});



function lockTitleHeight() {
  const titles = document.querySelectorAll('.j_custom_card .title');
  const description = document.querySelectorAll('.j_custom_card .short-desc-tile');
  let maxHeight = 0, maxHeightDesc = 0;
  
  description.forEach(desc => {
    desc.style.minHeight = '';
    desc.style.maxHeight = '';
  });
  
  // Reset first to get natural heights
  titles.forEach(title => {
    title.style.minHeight = '';
    title.style.maxHeight = '';
  });
  
  // Find max height
  description.forEach(desc => {
    const height = desc.offsetHeight;
    if (height > maxHeightDesc) maxHeightDesc = height;
  });
  
  titles.forEach(title => {
    const height = title.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });
  
  // Set all to max height
  description.forEach(desc => {
    desc.style.minHeight = maxHeightDesc + 'px';
    desc.style.maxHeight = maxHeightDesc + 'px';
  });
  
  titles.forEach(title => {
    title.style.minHeight = maxHeight + 'px';
    title.style.maxHeight = maxHeight + 'px';
  });
}

// Initial call
window.addEventListener('load', lockTitleHeight);
// Update on resize
window.addEventListener('resize', lockTitleHeight);